<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.school_name" placeholder="输入校区名称" @on-search="handleSearch" style="width:100%;" />
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row style='margin-bottom: 20px;'>
                <Col span="14">
                    <span>所属地区：</span>
                    <Select v-model="formItem.province_id" placeholder="请选择" @on-change="changeProvince" label-in-value clearable style="width:160px">
                        <Option v-for="item in provinceList" :value="item.province_id" :key="item.province_id">{{ item.province_name }}</Option>
                    </Select>
                    <Select ref='citySelect' v-model="formItem.city_id" placeholder="请选择" @on-change="changeCity" label-in-value clearable style="width:160px;">
                        <Option v-for="item in cityList" :value="item.city_id" :key="item.city_id">{{ item.city_name }}</Option>
                    </Select>
                    <Select ref='areaSelect' v-model="formItem.area_id" placeholder="请选择" @on-change="changeArea" label-in-value clearable style="width:160px">
                        <Option v-for="item in areaList" :value="item.area_id" :key="item.area_id">{{ item.area_name }}</Option>
                    </Select>
                </Col>
                <Col span="6">
                    <Select v-model="formItem.proxy_id" placeholder="请选择代理" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in proxyList" :value="item.proxy_id" :key="item.proxy_id">{{ item.proxy_name }}</Option>
                    </Select>
                </Col>
                <Col span="4">
                    <Select v-model="formItem.status" placeholder="审核状态" @on-change="handleSearch"  clearable style="width:160px">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
         <Modal v-model="addModel" width="800" :title="modalTitle">
            <div v-if='addModel'>
                <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
                    <Row>
                        <Col span="11">
                        <FormItem label="校区名称" prop='school_name'>
                            <Input v-model="formData.school_name" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                        <FormItem label="负责人" prop='realname'>
                            <Input v-model="formData.realname" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="20">
                        <FormItem label="所在省市" prop='province_id'>
                            <Select v-model="formData.province_id" placeholder="请选择" @on-change="changeProvince" label-in-value clearable style="width:200px">
                                <Option v-for="item in provinceList" :value="item.province_id" :key="item.province_id">{{ item.province_name }}</Option>
                            </Select>
                            <Select ref='citySelects' v-model="formData.city_id" placeholder="请选择" @on-change="changeCity" label-in-value clearable style="width:200px;margin:0 10px;">
                                <Option v-for="item in cityList" :value="item.city_id" :key="item.city_id">{{ item.city_name }}</Option>
                            </Select>
                            <Select ref='areaSelects' v-model="formData.area_id" placeholder="请选择" @on-change="changeArea" label-in-value clearable style="width:200px">
                                <Option v-for="item in areaList" :value="item.area_id" :key="item.area_id">{{ item.area_name }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                        <FormItem label="详细地址" prop='address'>
                            <Input v-model="formData.address" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                        <FormItem label="经营时间" prop='run_time'>
                            <Input v-model="formData.run_time" placeholder="请输入..." style='float:left;width:92%;margin-right:10px'></Input>年
                        </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                        <FormItem label="校区面积" prop='school_acreage'>
                            <Input v-model="formData.school_acreage" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                        <FormItem label="团队人数" prop='team_member_num'>
                            <Input v-model="formData.team_member_num" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                        <FormItem label="手机号码" prop='phone'>
                            <Input v-model="formData.phone" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                        <FormItem label="邮箱" prop='email'>
                            <Input v-model="formData.email" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                        <FormItem label="登录账号" prop='username'>
                            <Input v-model="formData.username" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                        <FormItem label="登录密码" prop='password'>
                            <Input v-model="formData.password" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                        <FormItem label="座机号" prop='landline'>
                            <Input v-model="formData.landline" placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
    
                    </Row>
                    <FormItem label="上传公司资质" prop='file_url'>
                        <UploadImg @getPicList="getPicList" v-if='addModel' :getList='formData.file_url' message='100' id='cover'></UploadImg>
                    </FormItem>
                    <Row>
                        <Col span="22">
                        <FormItem label="备注" prop='remark'>
                            <Input v-model="formData.remark" type='textarea' placeholder="请输入..."></Input>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
                <Button type="primary" shape="circle" @click="save('formData')">确定</Button>
    
            </div>
        </Modal>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
        <Modal v-model="reasonModal" width="600" title='拒绝理由'>
            <Form ref="applyForm" :model="applyForm" label-position="top">
                <FormItem label="拒绝理由" prop='remark'>
                    <Input v-model="applyForm.reason" type='textarea' placeholder="请输入..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
         <Modal v-model="rechargeModal" width="600" title='充值'>
            <Form ref="rechargeForm" :model="rechargeForm" label-position="top">
                <FormItem label="充值金额" prop='money'>
                    <Input v-model="rechargeForm.money"  placeholder="请输入..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRecharge'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRecharge('rechargeForm')">确定</Button>
            </div>
        </Modal>
        
        <Modal v-model="infoModel" width="600" title="查看详情">
            <div style='margin:10px 0;'>
                校区名称：{{infoData.school_name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 所属省市：{{infoData.province_name}}{{infoData.city_name}}{{infoData.area_name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 详细地址：{{infoData.address}} 
            </div>
            <div style='margin:10px 0;'>
                负责人：{{infoData.realname}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 经营时间：{{infoData.run_time}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 校区面积：{{infoData.school_acreage}} 
            </div>
            <div style='margin:10px 0;'>
                团队人数：{{infoData.team_member_num}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 代理：
                    <Select v-model="infoData.proxy_id" placeholder="请选择代理" clearable style="width:200px">
                        <Option v-for="item in proxyList" :value="item.proxy_id" :key="item.proxy_id">{{ item.proxy_name }}</Option>
                    </Select> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 学生人数：{{infoData.student_num}} 
            </div>
            <div style='margin:10px 0;'>
                保证金：{{infoData.caution_money}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 合作期限：{{infoData.teamwork_time}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 充值金额：{{infoData.money}} 
            </div>
            <div style='margin:10px 0;'>
                手机号：{{infoData.phone}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 邮箱：{{infoData.email}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 座机号：{{infoData.landline}}
            </div>
            <div style='margin:10px 0;'>

                公司资质：<img v-for='item in infoData.file_url' :src="'https://storage.art-kangaroo.com'+item" alt="" style='width:100px;vertical-align: middle;'>
            </div>
            <div style='margin:10px 0;'>
                <span v-if='infoData.status==2'>拒绝理由：{{infoData.reason}} </span>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>关闭</Button>

                <Button type='primary' shape="circle" @click='updateProxy'>确定</Button>

            </div>      
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        fetchInfo,
        operate,
        modifyProxy,
        setRecharge,
        setStatus,
        addModify,
        setDel
       
    } from '@/api/schoolList'
    import {
        fetchProvinceList,
        fetchCityList,
        fetchAreaList,
        fetchProxyList,

    } from '@/api/common'
        import UploadImg from '../common/picture.vue'

    export default {
        name: 'user-components',
        components: {
            UploadImg,
        },
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    school_name: '', 
                    status:'',
                    province_id:'',
                    city_id:'',
                    area_id:'',
                    proxy_id:'',
                },
                applyForm:{
                    school_id:'',
                    type:'',
                    reason:'',
                },
                reasonModal:false,
                infoData:{},
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                rechargeModal:false,//充值弹层状态
                rechargeForm:{
                    school_id:'',
                    money:'',
                },
                statusList:[
                    {id:0,name:'待审核'},
                    {id:1,name:'已通过'},
                    {id:2,name:'已拒绝'},
                ],
                verificationRule: {
                    school_name: [{
                        required: true,
                        message: '校区名称不能为空'
                    }],
                    realname: [{
                        required: true,
                        message: '负责人不能为空'
                    }],
                    province_id: [{
                        required: true,
                        message: '所在省市不能为空'
                    }],
                    address: [{
                        required: true,
                        message: '详细地址不能为空'
                    }],
                    run_time: [{
                        required: true,
                        message: '经营时间不能为空'
                    }],
                    phone: [{
                        required: true,
                        message: '手机号码不能为空'
                    }],
                    username: [{
                        required: true,
                        message: '账号不能为空'
                    }],
                    // password: [{
                    //     required: true,
                    //     message: '密码不能为空'
                    // }],
                    email: [{
                        required: true,
                        message: '邮箱不能为空'
                    }],
                    school_acreage: [{
                        required: true,
                        message: '校区面积不能为空'
                    }],
                    team_member_num: [{
                        required: true,
                        message: '团队人数不能为空'
                    }],
                    file_url: [{
                        required: true,
                    }],
    
    
                }, //添加修改的表单验证规则
                infoModel:false,
                provinceList:[],
                cityList:[],
                areaList:[],
                proxyList:[],
                modalTitle:'新增',
                addModel:false,
                formData: {
                    school_id: '',
                    school_name: '',
                    province_id: '',
                    province_name: '',
                    city_id: '',
                    city_name: '',
                    area_id: '',
                    area_name: '',
                    address: '',
                    realname: '',
                    run_time: '',
                    school_acreage: '',
                    team_member_num: '',
                    phone: '',
                    username: '',
                    password: '',
                    email: '',
                    file_url: '',
                    remark: '',
                    landline: '',
    
                }, //添加修改的表单数据
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                        fixed:'left',
                    },
                
                    {
                        title: '校区ID',
                        align: 'center',
                        key: 'school_id',
                        width: 100,


                    },
                    {
                        title: '省份',
                        align: 'center',
                        key: 'province_name',
                        width: 120,

                    },
                    {
                        title: '所在城市',
                        align: 'center',
                        key: 'city_name',
                        width: 120,

                        
                    },
                    {
                        title: '区县',
                        align: 'center',
                        key: 'area_name',
                        width: 120, 
                    },
                    {
                        title: '校区名称',
                        align: 'center',
                        key: 'school_name',
                        width: 160,
                    },
                    {
                        title: '校区地址',
                        align: 'center',
                        key: 'address',
                        width: 260,
                    },
                    {
                        title: '所属代理',
                        align: 'center',
                        key: 'proxy_name',
                        width: 120,
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        width: 120,
                        render: (h, params) => {
                            if(params.row.status==0){
                                return h('span', '待审核')
                            }else if(params.row.status==1){
                                return h('span', '已通过')
                            }else{
                                return h('span', '已拒绝')
                            }   
                        }
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width: 150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 280,
                        render: (h, params) => {
                            if(params.row.status==0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.school_id)
                                            }
                                        }
                                    }, '修改'),
                                    
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.pass(params.row.school_id,'确定通过该校区吗？')
                                            }
                                        }
                                    }, '通过'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.refuse(params.row.school_id)
                                            }
                                        }
                                    }, '拒绝'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.seeInfo(params.row.school_id)
                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.school_id)
                                            }
                                        }
                                    }, '删除'),
                                ])
                            }else if(params.row.status==1){
                                if(params.row.master_status==0){
                                    return h('div', [
                                        h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    size: 'small',
                                                    ghost: true

                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.edit(params.row.school_id)
                                                    }
                                                }
                                            }, '修改'),
                                            h('Button', {
                                                props: {
                                                    type: 'info',
                                                    size: 'small',
                                                    ghost: true

                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.seeInfo(params.row.school_id)
                                                    }
                                                }
                                            }, '查看'),
                                            h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    size: 'small',
                                                    ghost: true

                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.changeStatus(params.row.school_id,'确定解封该校区吗？')
                                                    }
                                                }
                                            }, '解封'),
                                            h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    size: 'small',
                                                    ghost: true

                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.recharge(params.row.school_id)
                                                    }
                                                }
                                            }, '充值'),
                                             h('Button', {
                                                props: {
                                                    type: 'error',
                                                    size: 'small',
                                                    ghost: true
                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.delete(params.row.school_id)
                                                    }
                                                }
                                            }, '删除'),
                                            
                                        ])
                                }else{
                                    return h('div', [
                                        h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    size: 'small',
                                                    ghost: true

                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.edit(params.row.school_id)
                                                    }
                                                }
                                            }, '修改'),
                                            h('Button', {
                                                props: {
                                                    type: 'info',
                                                    size: 'small',
                                                    ghost: true

                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.seeInfo(params.row.school_id)
                                                    }
                                                }
                                            }, '查看'),
                                            h('Button', {
                                                props: {
                                                    type: 'error',
                                                    size: 'small',
                                                    ghost: true

                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.changeStatus(params.row.school_id,'确定封禁该校区吗？')
                                                    }
                                                }
                                            }, '封禁'),
                                            h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    size: 'small',
                                                    ghost: true

                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.recharge(params.row.school_id)
                                                    }
                                                }
                                            }, '充值'),
                                             h('Button', {
                                                props: {
                                                    type: 'error',
                                                    size: 'small',
                                                    ghost: true
                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.delete(params.row.school_id)
                                                    }
                                                }
                                            }, '删除'),
                                            
                                        ])
                                }
                                
                            }else{
                                return h('div', [
                                   h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.school_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.seeInfo(params.row.school_id)
                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.school_id)
                                            }
                                        }
                                    }, '删除'),
                                ])
                            }
                            
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 修改获取详情
            edit(id) {
                this.modalTitle = '修改';
                fetchInfo({
                    school_id: id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.formData = res.data;
                        this.formData.province_id = parseInt(this.formData.province_id);
                        this.getCityList(this.formData.province_id);
                        this.getAreaList(this.formData.city_id);
                        this.formData.city_id = parseInt(this.formData.city_id);
                        this.formData.area_id = parseInt(this.formData.area_id);

                        this.addModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            seeInfo(id){
                fetchInfo({
                    school_id:id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.infoData = res.data;
                        this.infoModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 保存新增和修改
            save(name){
                this.$refs[name].validate(valid => {
                    if (valid) {
                        addModify(this.formData).then(res => {
                            res = res.data;
                            if (res.code == 200) {
                                this.getData();
                                this.addModel=false;
                            } else if (res.code == 14001) {
                                this.$Message.error(res.msg)
                                this.$store.dispatch('handleLogOut').then(res => {
                                    this.$store.commit('clearOpenedSubmenu')
                                    this.$router.push({
                                    name: 'login'
                                    })
                                })
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    
                    }
                })
            },
            updateProxy(){
                modifyProxy({
                    school_id:this.infoData.school_id,
                    proxy_id:this.infoData.proxy_id,

                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.getData();

                        this.infoModel = false;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 充值
            recharge(id){
                this.rechargeForm.school_id=id;
                this.rechargeForm.money	='';
                this.rechargeModal=true;

            },
            primaryRecharge(name){
               
                this.$refs[name].validate(valid => {

                    if (valid) {
                        setRecharge(this.rechargeForm).then(res => {

                            res = res.data;
                            if (res.code == 200) {
                                this.getData();
                                this.rechargeModal = false;
                            } else if (res.code == 14001) {
                                this.$Message.error(res.msg)
                                this.$store.dispatch('handleLogOut').then(res => {
                                    this.$store.commit('clearOpenedSubmenu')
                                    this.$router.push({
                                        name: 'login'
                                    })
                                })
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
    
                    }
                })
            },
            // 通过校区
            pass(id,info){
                this.applyForm.school_id = id;
                this.applyForm.type=2;
                this.remindContent = info;
                this.remindModal = true; 
            },
            // 删除
            delete(id) {
                this.school_id = id;
                // this.applyForm.type=3;

                this.remindContent = '确定删除该校区吗？';
                this.remindModal = true; 
            },
            // 拒绝
            refuse(id){
                this.applyForm.school_id = id;
                this.applyForm.type=1;
                this.reasonModal=true;

            },
            // 改变状态
            changeStatus(id,info) {
                this.school_id = id;
                this.remindContent = info;
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){

                if(this.remindContent.indexOf('封')!=-1){
                    var status='';

                    if(this.remindContent.indexOf('解')!=-1){
                        status=1;
                    }else{
                        status=0;
                    }
                    setStatus({
                        school_id:this.school_id,
                        status:status,
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){

                            this.getData();

                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }else if(this.remindContent == '确定删除该校区吗？'){
                     setDel({
                        school_id:this.school_id,
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }else{
                    operate(this.applyForm).then(res => {
                        res=res.data;
                        if(res.code==200){

                            this.getData();
                            if(this.applyForm.type==1){
                                this.reasonModal=false;
                            }else{
                                this.remindModal=false;
                            }
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }
                
                
            },
             getProvinceList(){
                fetchProvinceList().then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.provinceList=res.data;
                         
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })

            },
            
            getCityList(id){
                fetchCityList({
                    province_id:id
                }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.cityList=res.data;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })

            },
            getAreaList(id){
                fetchAreaList({
                    city_id:id
                }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.areaList=res.data;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })

            },
            getProxyList(){
                fetchProxyList().then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.proxyList=res.data;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
            },
            changeProvince(obj) {
                 if(this.addModel){
                    this.$refs['citySelects'].$data.query = '';
                    if (this.formData.province_id) {
                        this.formData.province_name=obj.label;
                        this.getCityList(obj.value);
                    } else {
                        this.cityList = [];
                        this.areaList = [];
                        this.formData.province_id='';
                        this.formData.province_name='';
                        this.formData.city_id = '';
                        this.formData.city_name = '';
                        this.formData.area_id = '';
                        this.formData.area_name = '';

                    }
                }else{
                    this.$refs['citySelect'].$data.query = '';
        
                    if (this.formItem.province_id) {
                        this.getCityList(this.formItem.province_id);
                        this.formItem.page=1;

                        this.getData()

                    } else {
                        this.cityList = [];
                        this.areaList = [];
                        this.formItem.city_id = '';
                        this.formItem.city_name = '';

                        this.formItem.area_id = '';
                        this.formItem.area_name = '';

                    }
                }
                
            },
            changeCity(obj) {
                 if(this.addModel){
                    this.$refs['areaSelects'].$data.query = '';
                    if (this.formData.city_id) {
                        this.formData.city_name=obj.label;
                        this.getAreaList(obj.value);
                    } else {
                        this.areaList = [];
                        this.formData.city_id = '';
                        this.formData.city_name = '';
                        this.formData.area_id = '';
                        this.formData.area_name = '';
                    }
                }else{
                    this.$refs['areaSelect'].$data.query = '';
                    if (this.formItem.city_id) {
                        this.getAreaList(this.formItem.city_id);
                        this.formItem.page=1;
                        this.getData()
        
                    } else {
                        this.areaList = [];
                        this.formItem.area_id = '';
                    }
                }
            },
            changeArea(obj) {
                if(this.addModel){
                    if (this.formData.area_id) {
                        this.formData.area_name=obj.label;
                    } else {
                        this.formData.area_id = '';
                        this.formData.area_name = '';
                    }   
                }else{
                    if (this.formItem.area_id) {
                        this.formItem.page=1;
                        
                        this.getData()
                    } else {
                        this.formItem.page = 1;
                        this.getData()
                    }
                }
    
            },
             getPicList(picList) {
                var arr = [];
                for (var i = 0; i < picList.length; i++) {
                    arr.push(picList[i].url.split('.com')[1])
                }
                this.formData.file_url = arr;
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.infoModel=false;
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
                this.reasonModal=false;

            },
            cancelRecharge(){
                this.rechargeModal=false
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
            this.getProvinceList();
            this.getProxyList();

        }
    };
</script>
